import React from 'react'
import { useParams } from "react-router-dom"
import { useTranslate } from "ra-core"
import { RecordActionsTabs, SubTabProps } from "components/ui/layouts"
import { Title } from "react-admin"
import BarChartIcon from "@mui/icons-material/BarChart"
import TableIcon from "@mui/icons-material/TableRowsTwoTone"
import ScheduleIcon from "@mui/icons-material/Schedule"
import { Box } from '@mui/material'
import { AuditTable, FieldConfig } from 'components/audit'

const TabList = () => {
    const translate = useTranslate()

    const subTabs: SubTabProps[] = [
        { label: translate("resources.schedules.name"), name: "schedules", resource: "companies", icon: <ScheduleIcon/> },
    ]

    return (
        <Box display="flex" flexDirection="column" width="100%">
           <RecordActionsTabs subTabs={subTabs} resourceParent="companies" />
        </Box>
    )
}

// Пример использования компонента AuditTable на отдельной странице
export const CompanyAuditHistoryPage = () => {
  const { id } = useParams<{ id: string }>()
  const translate = useTranslate()
  const deviceConfigs: FieldConfig[] = [
    { field: 'name', label: translate("resources.companies.fields.name"), visible: true },
    { field: 'short_name', label: translate("resources.companies.fields.short_name"), visible: true },
    { field: 'email', label: translate("resources.companies.fields.email"), visible: true },
    { field: 'type_id', label: translate("resources.companies.fields.type_id"), visible: true },
    { field: 'parent_id', label: translate("resources.companies.fields.parent_id"), visible: true },
    { field: 'description', label: translate("resources.common.fields.description"), visible: true },
  ]


  return (
     <>
        <Title title={translate('internal.audit')}/>
        <TabList />
        <AuditTable 
          tableName="companies"
          recordId={id!}
          showUserColumn={true}
          dense={false}
          className="audit-history-table"
          fieldConfigs={deviceConfigs}
        />
     </>
  )
}

export default CompanyAuditHistoryPage
